import { ReactNode, lazy, Suspense } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useServiceStatus } from "./OnboardingPaused";

const Chatbot = lazy(() => import("./Chatbot"));
const ActivityNotifications = lazy(() => import("./ActivityNotifications"));


const Layout = ({ children }: { children: ReactNode }) => {
  const { paused } = useServiceStatus();
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className={paused ? "flex-1 pt-[100px] sm:pt-[104px]" : "flex-1 pt-16"}>{children}</main>
      <Footer />
      <Suspense fallback={null}>
        <Chatbot />
        <ActivityNotifications />
      </Suspense>
    </div>
  );
};

export default Layout;
